export default __webpack_public_path__ + "static/mt_banner-6d15fced9428d7b63c7997a41a6290ec.png";